<script lang="ts">
  import { link } from "svelte-routing"
  import { Button, Col, Container, Row } from "sveltestrap"
  import BidTable from "../components/BidTable.svelte"
  import { connected } from "svelte-web3"

  if (!$connected) {
    window.location.href = '/'
  }
</script>

<Row>
  <div class="page-header"></div>
</Row>
<Container>
  <Row>
    <Col class="page-title pf-header">
      My portfolio
    </Col>
  </Row>
  <Row>
    <Col class="col-auto pf-tab">
      <a href="/portfolio/positions" use:link>
        Positions
      </a>
    </Col>
    <Col class="col-auto pf-tab pf-tab-activate">
      <a href="#">
        My bid offers
      </a>
    </Col>
  </Row>
  <Row>
    <Col class="pf-subtitle-bids">
      My bid offers
    </Col>
  </Row>
  <Row>
    <Col class="pf-table">
      <BidTable />
    </Col>
  </Row>
  <Row>
    <Col class="text-center">
      <a href="#top">
        <Button class="button-line pf-table-button">
          <img class="icon-small" src="/icons/arrow-top.svg" alt="placeholder"/>
          To the top
        </Button>
      </a>
    </Col>
  </Row>
</Container>
